//获取ai分析行为
export function getAIAnalysisBehavior() {
  return [
    { label: '使用手机', value: 1 },
    { label: '注视黑板', value: 2 },
    { label: '转向', value: 3 },
    { label: '趴桌子', value: 4 },
    { label: '阅读书写', value: 5 },
    { label: '起身', value: 6 },
    { label: '传递东西', value: 7 },
    { label: '吃东西', value: 8 },
  ]
}

export function functionList2() {
  return [
    {
      id: '02',
      label: '工作台（02）',
      children: [],
    },
  ]
}
export function functionList3() {
  return [
    {
      id: '03',
      label: '在线课堂（03）',
      children: [
        {
          id: '03-01',
          label: '我的开课',
          children: [
            {
              id: '03-01-01',
              label: '课堂详情',
            },
          ],
        },
      ],
    },
  ]
}

//获取文件类型
export function getFileType(fileType) {
  switch (fileType) {
    case 1:
      return 'word'
    case 2:
      return 'excel'
    case 3:
      return 'ppt'
    case 4:
      return 'pdf'
    case 5:
      return '视频'
  }
}
